import Header from '@/components/Header'
import Navigation from '@/components/Navigation'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { resetHrModeOnHome } from '../utils/hr'

const Home: React.FC = () => {
  const navigate = useNavigate()
  
  // 只在Home页面刷新时重置isHr
  useEffect(() => {
    resetHrModeOnHome()
  }, [])
  
  const navigateTo = (path: string) => {
    navigate(path)
  }

  return (
    <div className="home-root">
      <Header />
      <Navigation/>
      <div className="container">
        <header className="header">
          <div className="header-content">
            <i className="fas fa-tachometer-alt header-icon" />
            <h1>HR产假津贴管理系统</h1>
            <p className="subtitle">统一管理产假计算、津贴补差，支持个人查询和批量处理</p>
          </div>
        </header>

        <main className="dashboard-content">
          <div className="feature-grid">
            {/* 个人产假计算 */}
            <div className="feature-card" onClick={() => navigateTo('/maternity')}>
              <div className="feature-icon individual">
                <i className="fas fa-baby" />
              </div>
              <div className="feature-content">
                <h3>个人产假计算</h3>
                <p>支持全国14个城市的产假时间计算，为女性员工提供准确的产假安排</p>
                <div className="feature-details">
                  <span className="detail-item"><i className="fas fa-map-marker-alt" /> 14个城市</span>
                  <span className="detail-item"><i className="fas fa-calendar-alt" /> 精确计算</span>
                  <span className="detail-item"><i className="fas fa-user" /> 个人使用</span>
                </div>
              </div>
              <div className="feature-arrow">
                <i className="fas fa-chevron-right" />
              </div>
            </div>

            {/* 个人津贴补差计算 */}
            <div className="feature-card" onClick={() => navigateTo('/allowance')}>
              <div className="feature-icon individual">
                <i className="fas fa-money-bill-wave" />
              </div>
              <div className="feature-content">
                <h3>个人津贴补差计算</h3>
                <p>根据各城市政策计算生育津贴补差金额，确保员工权益保障</p>
                <div className="feature-details">
                  <span className="detail-item"><i className="fas fa-calculator" /> 智能计算</span>
                  <span className="detail-item"><i className="fas fa-balance-scale" /> 政策合规</span>
                  <span className="detail-item"><i className="fas fa-user" /> 个人使用</span>
                </div>
              </div>
              <div className="feature-arrow">
                <i className="fas fa-chevron-right" />
              </div>
            </div>

            {/* 历史记录 */}
            <div className="feature-card" onClick={() => navigateTo('/history')}>
              <div className="feature-icon batch">
                <i className="fas fa-history" />
              </div>
              <div className="feature-content">
                <h3>历史记录</h3>
                <p>查看和管理历史计算记录，支持快速查询和数据导出</p>
                <div className="feature-details">
                  <span className="detail-item"><i className="fas fa-search" /> 快速查询</span>
                  <span className="detail-item"><i className="fas fa-download" /> 数据导出</span>
                  <span className="detail-item"><i className="fas fa-user" /> 个人使用</span>
                </div>
              </div>
              <div className="feature-arrow">
                <i className="fas fa-chevron-right" />
              </div>
            </div>
          </div>

          {/* 系统说明 */}
          <div className="info-section">
            <div className="info-card">
              <div className="card-header">
                <h3><i className="fas fa-info-circle" /> 系统功能说明</h3>
              </div>
              <div className="info-content">
                <div className="info-grid">
                  <div className="info-item">
                    <h4><i className="fas fa-baby" /> 产假计算</h4>
                    <ul>
                      <li>支持全国14个主要城市</li>
                      <li>自动识别城市政策差异</li>
                      <li>考虑难产、多胞胎等特殊情况</li>
                      <li>精确到天的计算结果</li>
                    </ul>
                  </div>
                  <div className="info-item">
                    <h4><i className="fas fa-money-bill-wave" /> 津贴补差</h4>
                    <ul>
                      <li>基于各城市具体政策</li>
                      <li>区分企业承担和个人承担</li>
                      <li>自动计算补差金额</li>
                      <li>提供处理建议和政策依据</li>
                    </ul>
                  </div>
                  <div className="info-item">
                    <h4><i className="fas fa-history" /> 历史记录</h4>
                    <ul>
                      <li>查看所有计算历史</li>
                      <li>快速搜索和筛选</li>
                      <li>支持数据导出</li>
                      <li>便于追溯和管理</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 快速操作 */}
          <div className="quick-actions">
            <h3><i className="fas fa-bolt" /> 快速操作</h3>
            <div className="action-buttons">
              <button className="action-btn primary" onClick={() => navigateTo('/maternity')}>
                <i className="fas fa-calculator" />
                计算产假
              </button>
              <button className="action-btn secondary" onClick={() => navigateTo('/allowance')}>
                <i className="fas fa-money-check-alt" />
                计算补差
              </button>
              <button className="action-btn batch" onClick={() => navigateTo('/history')}>
                <i className="fas fa-history" />
                历史记录
              </button>
            </div>
          </div>
        </main>

        <footer className="footer">
          <p>© 2025 Twins HR产假津贴管理系统 | 仅供内部使用</p>
        </footer>
      </div>
    </div>
  )
}

export default Home
